import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { ModalService } from 'src/app/services/modal.service';
import { campus } from 'src/app/shared/models/campus';
import { recommendation } from 'src/app/shared/models/recommendation';
import { AdminService } from '../../services/admin.service';
import { AuthService } from '../../services/auth.service';
import { GlobalService } from '../../services/global.service';
import { InternService } from '../../services/intern.service';
import { EmailComponent } from '../../shared/email/email.component';
import { certificate } from '../../shared/models/certificate';
import { EmailModel } from '../../shared/models/email-model';
import { EmailRecipient } from '../../shared/models/email-recipient';
import { FieldSupervisor } from '../../shared/models/fsupervisor.model';
import { internCertDetails } from '../../shared/models/internCertDetails';
import { NewContactComponent } from 'src/app/shared/new-contact/new-contact.component';
import { SelectedIntern } from 'src/app/shared/models/selected-intern.model';
import { CachedFsContact } from 'src/app/shared/models/cached-fs-contact.model';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { CompanyEnum } from 'src/app/shared/enums/company-enum.model';
import { State } from 'src/app/shared/models/state.model';
import { assessmentSummary, scheduledAssessment } from 'src/app/shared/models/assessment-summary';

@Component({
  standalone: false,
  selector: 'app-intern-search',
  templateUrl: './intern-search.component.html',
  styleUrls: ['./intern-search.component.scss']
})
export class InternSearchComponent implements OnDestroy, OnInit {
  form = new UntypedFormGroup({});

  @ViewChild('campus') campus: ElementRef<HTMLSelectElement>;
  @ViewChild('obscriteria') obscriteria: ElementRef<HTMLSelectElement>;
  @ViewChild('recommendation') recommendation: ElementRef<HTMLSelectElement>;
  @ViewChild('comments') comments: ElementRef<HTMLInputElement>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  //List of displayed columns
  standardDisplayedColumns: string[] = ['select', 'reverseFullName', 'isDistrictSelect', 'districtName', 'campusName', 'assigned', 'trackStart'
    , 'initialContact', 'firstObsDeadLine', 'secondObsDeadLine', 'thirdObsDeadLine'
    , 'recommendationStatus', 'principalRecommendationStatus'];

  defaultDisplayedColumns: string[] = ['select', 'reverseFullName', 'isDistrictSelect', 'districtName', 'campusName', 'assigned', 'trackStart'
    , 'initialContact', 'firstObsDeadLine', 'secondObsDeadLine', 'thirdObsDeadLine'
    , 'forthObsDeadLine', 'fifthObsDeadLine', 'sixthObsDeadLine', 'recommendationStatus', 'principalRecommendationStatus'];

  extendDisplayedColumns: string[] = ['select', 'reverseFullName', 'isDistrictSelect', 'districtName', 'campusName', 'assigned', 'trackStart'
    , 'initialContact', 'firstObsDeadLine', 'secondObsDeadLine', 'thirdObsDeadLine'
    , 'forthObsDeadLine', 'fifthObsDeadLine', 'sixthObsDeadLine', 'seventhObsDeadLine', 'recommendationStatus', 'principalRecommendationStatus'];

  teachDisplayedColumns: string[] = ['select', 'reverseFullName', 'isDistrictSelect', 'districtName', 'campusName', 'assigned', 'trackStart'
    , 'monthlyMeeting', 'firstObsDeadLine', 'secondObsDeadLine', 'thirdObsDeadLine'
    , 'forthObsDeadLine', 'fifthObsDeadLine', 'sixthObsDeadLine', 'recommendationStatus', 'principalRecommendationStatus'];

  displayedColumns: string[] = this.defaultDisplayedColumns;

  texasObservationGroupHeaderColumns: string[] = [
    'groupSpacerStart',
    'groupFormalObservation',
    'groupInformalObservation',
    'groupConference',
    'groupSpacerEnd'
  ];

  //Mat datasource to populate intern dashboard table
  dataSource: any;
  //Mat array to handle selection
  selection = new SelectionModel<certificate>(true, []);
  //Used to get data to generate PDF
  lstcertDetails: internCertDetails[] = [];
  //Keeps the original data from API
  lstcert: certificate[] = [];
  //Used to display data after apply filters
  lstcertsearch: certificate[] = [];
  //Flag to display or not loading spinner
  showLoading: boolean = false;
  strUNDEFINED: string = "UNDEFINED";
  isExpansionState: boolean = false;

  supervisor: FieldSupervisor;
  lstCompletedAllObs: certificate[] = [];
  lstNotCompletedAllObs: certificate[] = [];
  lstcampus: campus[] = [];
  selectedInternId: number = 0;
  selectedCertificate = new certificate;
  durationInSeconds = 5;
  today = new Date();
  isDistrictSelectCheckboxChecked: boolean = false;
  showOnlyDistrictSelectInterns: boolean;
  observationCriteriaSelection: string;
  campusSelection: string;
  stateSelection: string = '0';
  appliedStateSelection: string = '0';
  supervisorCertifiedStates: State[] = [];
  selectedInterns: SelectedIntern[] = [];
  newRuleSetStartingYear: number = 2024;
  private readonly texasRuleSetPrefix: string = 'TX';
  private readonly ruleSet2026SettingCategory: string = 'FSPortal';
  private readonly ruleSet2026SettingKey: string = 'TXRuleSet2026StartDate';
  private ruleSet2026StartDate: Date = null;
  private hasLoadedCertificates: boolean = false;
  private hasLoadedStates: boolean = false;
  private filtersInitialized: boolean = false;
  constructor(private internService: InternService, private modalService: ModalService,
    private datePipe: DatePipe, private _snackBar: MatSnackBar,
    public dialog: MatDialog, private authService: AuthService, private router: Router,
    private globalService: GlobalService, private themeService: ThemeService,
    private adminService: AdminService) {
  }

  ngOnInit() {
    if (!this.authService.authenticated) {
      this.router.navigate(['auth']);
    }

    if (this.authService.authenticated) {
      console.log("Global service supervisor", this.globalService.supervisor);
      if (this.globalService.supervisor != undefined) {
        this.supervisor = this.globalService.supervisor;
        this.themeService.setTheme(this.supervisor.CompanyId);
      }
    }
    this.getInterns();
    this.setupColumns();
    this.loadRuleSet2026StartDate();
    this.refreshTable();
    this.removeExpiredCachedFsContacts();
  }

  private loadRuleSet2026StartDate() {
    this.adminService.getAppSettingValue(this.ruleSet2026SettingCategory, this.ruleSet2026SettingKey)
      .then(setting => {
        const startDate = new Date(setting?.value);
        this.ruleSet2026StartDate = isNaN(startDate.getTime()) ? null : startDate;
      })
      .catch(error => console.log(`error loading ${this.ruleSet2026SettingKey} ${error}`));
  }

  ngAfterViewInit() {
  }

  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Intern List',
    useBom: true,
    noDownload: false,
    headers: ["INTERN NAME", "DIST", "CAMPUS", "ASSIGNED", "TRACK START", "1ST OBS", "2ND OBS", "3RD OBS", "4TH OBS", "5TH OBS", "6TH OBS", "RCMD"]
  };

  downloadCSV() {
    if (this.selection.selected.length <= 0) {
      this.openSnackBar("Select one or more interns", "Error");
      return;
    }

    if (this.isTexasStateFilterSelected) {
      this.downloadTexasCSV();
      return;
    }

    this.downloadDefaultCSV();
  }

  private downloadDefaultCSV() {
    this.csvOptions.headers = ["INTERN NAME", "DIST", "CAMPUS", "ASSIGNED", "TRACK START", "1ST OBS", "2ND OBS", "3RD OBS", "4TH OBS", "5TH OBS", "6TH OBS", "RCMD"];

    const downloadinternlst = this.selection.selected.map(element => ({
      "INTERN NAME": element.reverseFullName,
      "DIST": element.districtName,
      "CAMPUS": element.campusName,
      "ASSIGNED": this.formatExportDate(element.assigned),
      "TRACK START": this.formatExportDate(element.trackStart),
      "1ST OBS": this.formatExportDate(element.firstObsDeadLine),
      "2ND OBS": this.formatExportDate(element.secondObsDeadLine),
      "3RD OBS": this.formatExportDate(element.thirdObsDeadLine),
      "4TH OBS": this.formatExportDate(element.forthObsDeadLine),
      "5TH OBS": this.formatExportDate(element.fifthObsDeadLine),
      "6TH OBS": this.formatExportDate(element.sixthObsDeadLine),
      "RCMD": (element.recommendationStatus != null) ? element.recommendationStatus : ""
    }));

    new AngularCsv(downloadinternlst, "InternList", this.csvOptions);
  }

  private downloadTexasCSV() {
    const formalColumnCount = this.getMaxDueDateSequence(summary => summary.formalObsDueDates);
    const informalColumnCount = this.getMaxDueDateSequence(summary => summary.informalObsDueDates);
    const conferenceColumnCount = this.getMaxDueDateSequence(summary => summary.conferenceDueDates);

    const formalHeaders = this.buildDueDateHeaders(formalColumnCount, 'OBS');
    const informalHeaders = this.buildDueDateHeaders(informalColumnCount, 'INFORMAL');
    const conferenceHeaders = this.buildDueDateHeaders(conferenceColumnCount, 'CONFERENCE');

    const texasHeaders = [
      'INTERN NAME', 'DIST', 'CAMPUS', 'ASSIGNED', 'TRACK START',
      'PROGRESS', 'NEXT DATE', ...formalHeaders,
      'PROGRESS', 'NEXT DATE', ...informalHeaders,
      'PROGRESS', 'NEXT DATE', ...conferenceHeaders,
      'RCMD'
    ];

    const groupHeaderRow = [
      '', '', '', '', '',
      'Formal Observations', ...this.buildGroupHeaderPadding(formalColumnCount),
      'Informal Observations', ...this.buildGroupHeaderPadding(informalColumnCount),
      'Conferences', ...this.buildGroupHeaderPadding(conferenceColumnCount),
      ''
    ];

    const rows: string[][] = [
      ['Intern List'],
      [],
      groupHeaderRow,
      texasHeaders,
      ...this.selection.selected.map(element => {
        const summary = element.assessmentSummary;

        return [
          element.reverseFullName ?? '',
          element.districtName ?? '',
          element.campusName ?? '',
          this.formatExportDate(element.assigned),
          this.formatExportDate(element.trackStart),
          this.toExcelText(summary?.obsProgress),
          this.formatExportDate(summary?.nextObsDate),
          ...this.buildDueDateCells(summary?.formalObsDueDates, formalColumnCount),
          this.toExcelText(summary?.informalObsProgress),
          this.formatExportDate(summary?.nextInformalObsDate),
          ...this.buildDueDateCells(summary?.informalObsDueDates, informalColumnCount),
          this.toExcelText(summary?.conferenceProgress),
          this.formatExportDate(summary?.nextConferenceDate),
          ...this.buildDueDateCells(summary?.conferenceDueDates, conferenceColumnCount),
          element.recommendationStatus ?? ''
        ];
      })
    ];

    const csvContent = rows
      .map(row => row.map(value => this.toCsvCell(value)).join(','))
      .join('\r\n');

    const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
    const downloadUrl = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = 'InternList.csv';
    downloadLink.click();
    URL.revokeObjectURL(downloadUrl);
  }

  private getMaxDueDateSequence(selectDueDates: (summary: assessmentSummary) => scheduledAssessment[]): number {
    return this.selection.selected.reduce((maxSequence, element) => {
      const dueDates = element.assessmentSummary ? selectDueDates(element.assessmentSummary) ?? [] : [];

      return dueDates.reduce((groupMaxSequence, dueDate) => Math.max(groupMaxSequence, dueDate.sequence ?? 0), maxSequence);
    }, 0);
  }

  private buildDueDateHeaders(columnCount: number, groupSuffix: string): string[] {
    return Array.from({ length: columnCount }, (unusedValue, index) => `${this.toOrdinal(index + 1)} ${groupSuffix}`);
  }

  private buildGroupHeaderPadding(columnCount: number): string[] {
    return new Array<string>(columnCount + 1).fill('');
  }

  private buildDueDateCells(dueDates: scheduledAssessment[] | null | undefined, columnCount: number): string[] {
    const cells = new Array<string>(columnCount).fill('');

    (dueDates ?? []).forEach(dueDate => {
      const columnIndex = (dueDate.sequence ?? 0) - 1;

      if (columnIndex >= 0 && columnIndex < columnCount) {
        cells[columnIndex] = this.formatExportDate(dueDate.dueDate);
      }
    });

    return cells;
  }

  private toOrdinal(sequence: number): string {
    const ordinals = ['1ST', '2ND', '3RD', '4TH', '5TH', '6TH', '7TH', '8TH', '9TH', '10TH'];

    return ordinals[sequence - 1] ?? `${sequence}TH`;
  }

  private formatExportDate(value: Date | string | null | undefined): string {
    if (value == null) {
      return '';
    }

    return this.datePipe.transform(value, 'MM-dd-yyyy') ?? '';
  }

  private toExcelText(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }

    return `="${value.replace(/"/g, '""')}"`;
  }

  private toCsvCell(value: string | null | undefined): string {
    return `"${(value ?? '').replace(/"/g, '""')}"`;
  }

  loadFiltersFromSession() {
    this.observationCriteriaSelection = sessionStorage.getItem('observationCriteriaSelection') ?? '0';
    this.campusSelection = sessionStorage.getItem('campusSelection') ?? '0';
    const savedStateSelection = sessionStorage.getItem('stateSelection') ?? '';
    this.isDistrictSelectCheckboxChecked = (sessionStorage.getItem('isDistrictSelectCheckboxChecked') ?? 'false') === 'true';
    this.showOnlyDistrictSelectInterns = (sessionStorage.getItem('showOnlyDistrictSelectInterns') ?? 'false') === 'true';

    if (this.supervisorCertifiedStates.length > 1) {
      const defaultStateSelection = this.supervisorCertifiedStates[0].StateName;
      this.stateSelection = this.supervisorCertifiedStates.some(state => state.StateName === savedStateSelection)
        ? savedStateSelection
        : defaultStateSelection;
    } else {
      this.stateSelection = '0';
    }

    this.getInternsSearch();
  }

  getInternsSearch() {

    this.showLoading = true;

    if (this.lstcert) {

      this.appliedStateSelection = this.stateSelection;

      this.lstcertsearch = this.lstcert;

      //here we are filtering for observation criteria dropdown
      if (this.observationCriteriaSelection == '0') {
        this.lstcertsearch = this.lstcertsearch;
      } else if (this.observationCriteriaSelection == '2') {
        this.lstcertsearch = this.lstNotCompletedAllObs;
      }
      else if (this.observationCriteriaSelection == '1') {
        this.lstcertsearch = this.lstCompletedAllObs;
      }

      //here we are filtering for campus dropdown
      if (this.campusSelection == '0') {
        this.lstcertsearch = this.lstcertsearch;
      } else {
        this.lstcertsearch = this.lstcertsearch.filter(a => (a.campusName ?? '').toLowerCase() === (this.campusSelection ?? '').toLowerCase());
      }

      if (this.supervisorCertifiedStates.length > 1 && this.stateSelection && this.stateSelection !== '0') {
        this.lstcertsearch = this.lstcertsearch.filter(a => (a.stateName ?? '').toLowerCase() === this.stateSelection.toLowerCase());
      }
    }

    if (this.showOnlyDistrictSelectInterns) {
      this.isDistrictSelectCheckboxChecked = true;
      this.lstcertsearch = this.lstcertsearch.filter(rec => rec.isDistrictSelect == true);
    }

    sessionStorage.setItem('campusSelection', this.campusSelection);
    sessionStorage.setItem('observationCriteriaSelection', this.observationCriteriaSelection);
    sessionStorage.setItem('stateSelection', this.stateSelection ?? '0');
    sessionStorage.setItem('isDistrictSelectCheckboxChecked', this.isDistrictSelectCheckboxChecked.toString());
    sessionStorage.setItem('showOnlyDistrictSelectInterns', this.showOnlyDistrictSelectInterns.toString())

    this.selection.clear();

    this.refreshTable();

    this.showLoading = false;
  }

  getInterns() {

    this.showLoading = true;

    this.internService.getCertificatesBySupervisor(this.supervisor.FieldSupervisorId).subscribe(data => {

      if (data == undefined) {
        this.showLoading = false;
        return;
      }

      //sort apply default sort
      this.lstcert = data.sort((a, b) => a.lastName.localeCompare(b.lastName));

      this.lstcertsearch = this.lstcert;

      this.dataSource = new MatTableDataSource<certificate>(this.lstcert);

      //this.lstcertsearch = this.lstcert;
      //here we are loading campus data in dropdown
      this.lstcert.forEach(element => {
        var camp = new campus();
        camp.Name = element.campusName;
        camp.CampusId = element.campusId;
        camp.DistrictName = element.districtName;

        const isCampAvail = this.lstcampus.find(c => c.Name == camp.Name);
        if (!isCampAvail && camp.CampusId > 0) {

          this.lstcampus.push(camp);
        }

        //below logic is done to load data for observation criteria dropdown.
        if (element.allObsAreCompleted) {
          this.lstCompletedAllObs.push(element);
        } else {
          this.lstNotCompletedAllObs.push(element);
        }
      });

      //Sort list of campus
      if (this.lstcampus.length > 0) {
        this.lstcampus = this.lstcampus.sort((a, b) => a.Name.localeCompare(b.Name));
      }

      this.dataSource.sort = this.sort;

      this.hasLoadedCertificates = true;
      this.initializeFilters();

      this.showLoading = false;
    });
  }

  setupColumns() {
    this.internService.getSupervisorCertifiedStates(this.supervisor.FieldSupervisorId).subscribe(states => {
      this.supervisorCertifiedStates = (states ?? []).sort((a, b) => a.StateName.localeCompare(b.StateName));

      if (this.supervisor.CompanyId == CompanyEnum.Teach) {
        this.displayedColumns = this.teachDisplayedColumns;
        this.isExpansionState = true;
      }
      else if (this.supervisorCertifiedStates.findIndex(x => x.StateName == 'Michigan') >= 0) {
        this.displayedColumns = this.extendDisplayedColumns;
        this.isExpansionState = true;
      }
      else if (this.supervisorCertifiedStates.findIndex(x => x.StateName == 'Texas') >= 0) {
        this.displayedColumns = this.defaultDisplayedColumns;
        this.isExpansionState = false;
      }
      else {
        this.displayedColumns = this.standardDisplayedColumns;
        this.isExpansionState = true;
      }

      this.hasLoadedStates = true;
      this.initializeFilters();

    });
  }

  private initializeFilters() {
    if (this.filtersInitialized || !this.hasLoadedCertificates || !this.hasLoadedStates) {
      return;
    }

    this.filtersInitialized = true;
    this.loadFiltersFromSession();
  }

  get isTexasStateFilterSelected(): boolean {
    const hasTexasState = this.supervisorCertifiedStates.some(state => state.StateName === 'Texas');

    if (!hasTexasState) {
      return false;
    }

    if (this.supervisorCertifiedStates.length === 1) {
      return true;
    }

    return this.appliedStateSelection === 'Texas';
  }

  get showTexasObservationGroupHeaders(): boolean {
    return this.isTexasStateFilterSelected && this.displayedColumns === this.defaultDisplayedColumns;
  }

  reset() {

    this.observationCriteriaSelection = '0';
    this.campusSelection = '0';
    this.stateSelection = this.supervisorCertifiedStates.length > 1 ? this.supervisorCertifiedStates[0].StateName : '0';

    // clear the checkbox selection
    this.showOnlyDistrictSelectInterns = false;
    this.isDistrictSelectCheckboxChecked = false;

    this.getInternsSearch();
    this.selection.clear();
  }

  ngOnDestroy(): void {

  }

  closeNotification() {
    $("#dvnotify").hide();
  }

  sendEmail() {

    if (this.selection.selected.length > 0) {

      // create email model to pass as a data to email component
      let mailModel = new EmailModel;

      //Sending all posible emails for selection
      this.lstcert.forEach(intern => {
        let recipient = new EmailRecipient();
        recipient.email = intern.emailAddress;
        recipient.name = intern.firstName + ' ' + intern.lastName;
        recipient.profileId = intern.profileId;
        mailModel.allRecipients.push(recipient);
      });

      //Send list of selected interns
      this.selection.selected.forEach(selectedIntern => {
        let recipient = new EmailRecipient();
        recipient.email = selectedIntern.emailAddress;
        recipient.name = selectedIntern.firstName + ' ' + selectedIntern.lastName;
        recipient.profileId = selectedIntern.profileId;
        mailModel.bcc.push(recipient);
      });

      //Send list of selected interns
      this.selectedInterns = [];
      this.selection.selected.forEach(selectedIntern => {
        this.selectedInterns.push({
          internFullName: selectedIntern.firstName + ' ' + selectedIntern.lastName,
          firstName: selectedIntern.firstName,
          lastName: selectedIntern.lastName,
          email: selectedIntern.emailAddress,
          stateName: selectedIntern.stateName,
          internId: selectedIntern.internNumber.toString(),
          certProgramId: selectedIntern.certProgramID,
          profileId: selectedIntern.profileId
        });
      });

      //Map sender
      let fromRecipient = new EmailRecipient();
      mailModel.from = fromRecipient;

      //Open email Modal component
      const dialogRef = this.dialog.open(EmailComponent, {
        width: '800px',
        height: '750px',
        minHeight: '400px',
        minWidth: '600px',
        disableClose: true,
        data: { mailModel: mailModel, selectedInterns: this.selectedInterns, internCampusAdministrators: null, fieldSupervisor: this.supervisor },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.openSnackBar("Email Sent Successfully", "Okay");

        }
      });
    }
    else {
      this.openSnackBar("Select one or more interns", "Error");
    }
  }

  contactInterns() {

    if (this.selection.selected.length > 0) {

      //Send list of selected interns
      this.selectedInterns = [];
      this.selection.selected.forEach(selectedIntern => {
        this.selectedInterns.push({
          internFullName: selectedIntern.firstName + ' ' + selectedIntern.lastName,
          firstName: selectedIntern.firstName,
          lastName: selectedIntern.lastName,
          email: selectedIntern.emailAddress,
          stateName: selectedIntern.stateName,
          internId: selectedIntern.internNumber.toString(),
          certProgramId: selectedIntern.certProgramID,
          profileId: selectedIntern.profileId
        });
      });

      //Open New Contact Modal component
      const dialogRef = this.dialog.open(NewContactComponent, {
        width: '800px',
        height: '750px',
        minHeight: '400px',
        minWidth: '600px',
        data: this.selectedInterns,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.openSnackBar("New Contact Successful", "Success");

        }
      });
    }
    else {
      this.openSnackBar("Select one or more interns", "Error");
    }
  }


  AddRcmd() {

    this.modalService.close('interns-recommendation');

    let newRcmd = new recommendation();

    newRcmd.CertProgramId = this.selectedCertificate.certProgramID;
    newRcmd.RecommendationTypeId = +this.recommendation.nativeElement.value;
    newRcmd.Comment = this.comments.nativeElement.value;

    if (this.recommendation.nativeElement.value == '1') {
      this.selectedCertificate.recommendationStatus = 'Certify';
    }
    else if (this.recommendation.nativeElement.value == '2') {
      this.selectedCertificate.recommendationStatus = 'Extend';
    }
    else if (this.recommendation.nativeElement.value == '3') {

      this.selectedCertificate.recommendationStatus = 'Not Certify';
    }

    newRcmd.Date = new Date().toDateString();
    newRcmd.CreateUser = this.selectedCertificate.firstName;
    newRcmd.FsLastName = this.supervisor.FirstName;
    newRcmd.FsLastName = this.supervisor.LastName;
    newRcmd.CoachTypeId = 1;


    console.log("Before call service with new typeid: " + newRcmd.RecommendationTypeId.toString() + " CertID: " + newRcmd.CertProgramId.toString());
    this.internService.AddRecommendation(newRcmd).subscribe(rcmd => { console.log(rcmd.CertProgramId.toString()) });
  }

  closeRecModal() {
    this.modalService.close('interns-recommendation');
  }

  openrecommendation(id: number) {
    console.log('opening add recommendation for id: ' + id);
    this.selectedInternId = id;

    let certInfo = this.lstcertsearch
      .find(x => x.internNumber == this.selectedInternId);

    if (certInfo) {
      console.log('object found!');
      this.selectedCertificate = certInfo;
    }

    this.modalService.open('interns-recommendation');
  }

  ChangeClassByCondition(statusCode: string, deadline: Date, texasSummaryValue: string | Date | null, isNext4Weeks: boolean | null, isPastDue: boolean | null) {
    let className = "defaultCellBackground";

    if (this.isTexasStateFilterSelected) {
      className = "defaultCellBackground";
      if (texasSummaryValue == null) {
        className = "non-scheduled";
      }

      if (isNext4Weeks) {
        className = "next-four-weeks";
      }

      if (isPastDue) {
        className = "past-due";
      }

      return className;
    }

    if (statusCode == null) {
      return className;
    }

    switch (statusCode) {
      case "DateValue": {
        const differenceInDays = this.getDifference(deadline, this.today);
        if (differenceInDays <= 28) {
          className = 'next-four-weeks'
        }
        if (differenceInDays < 0) {
          className = 'past-due'
        }
        break;
      }
      case "Tardy": {
        className = 'tardy';
        break;
      }
      case "Approved": {
        className = 'approved';
        break;
      }
      case "Missed": {
        className = 'missed';
        break;
      }
      default: {
        break;
      }
    }

    return className;

  }

  IsObservationComplete(statusCode) {
    let validCompleteStatus = ['Approved', 'Accepted', 'Waived', 'Missed'];
    return validCompleteStatus.includes(statusCode);
  }

  GetObservationStatus(statusCode, endDate, scheduledDate) {

    let hasEndDate = endDate !== null || endDate !== undefined;
    if (this.IsObservationComplete(statusCode) == false) {
      if (hasEndDate && statusCode != 'Scheduled') {
        return statusCode;
      }
      else {
        return this.datePipe.transform(scheduledDate, 'MM/dd/yyyy');
      }
    }
  }

  ChangeClassByAssignedDate(assigned) {
    let className = "defaultCellBackground";
    const differenceInDays = this.getDifference(this.today, assigned);
    if (differenceInDays <= 14) {
      className = 'new-intern'
    }
    return className;
  }

  getDifference(date1: any, date2: any) {
    date1 = new Date(date1);
    date2 = new Date(date2);
    return (date1.getTime() - date2.getTime()) / (1000 * 3600 * 24);
  }

  //Generates a snackBar notification
  openSnackBar(data: string, status: string) {
    this._snackBar.open(data, status, {
      duration: this.durationInSeconds * 1500,
      panelClass: 'custom-snackbar'
    });
  }

  async exportToPdf() {

    if (this.selection != null && this.selection.selected.length > 0) {
      this.getDataToPDF();

      await this.delay(3000);
      this.openSnackBar("Generating PDF", "")
      this.generatePDF();
    }
    else {
      this.openSnackBar("Select one or more interns", "Error");
    }
  }

  getDataToPDF() {

    if (this.selection != null && this.selection.selected.length > 0) {

      let selectedIds: string = ",";

      this.selection.selected.forEach(element => {
        selectedIds += element.internNumber + ',';
      });

      this.internService.getSelectedInternDetails(selectedIds).subscribe(data => {
        this.lstcertDetails = data;
      });
    }
    else {
      this.openSnackBar("Select one or more interns", "Error");
    }
  }

  generatePDF() {
    var data = document.getElementById('internDataPDF');
    data.style.display = "block";

    html2canvas(data).then(canvas => {

      // Few necessary setting options
      var imgWidth = 195;
      var pageHeight = 295;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
      var position = 10;
      pdf.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save('InterDetails.pdf'); // Generated PDF
      data.style.display = "none";
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  addDays(date: Date, days: number) {
    let result = new Date(date);
    return result.setDate(result.getDate() + days);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.filter(row => row.certType != this.strUNDEFINED).length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => row.certType != this.strUNDEFINED && this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: certificate): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.internNumber + 1}`;
  }

  refreshTable() {
    //Refresh Table
    this.dataSource = new MatTableDataSource<certificate>(this.lstcertsearch);
    this.dataSource.sort = this.sort;
  }

  IsCertTypeUndefined(row: certificate) {
    return row.certType == this.strUNDEFINED;
  }

  IsRowBroken(row: certificate) {
    var isBroken: Boolean = false;
    isBroken = isBroken || this.IsCertTypeUndefined(row);
    return isBroken;
  }

  GetBrokenRowMessages(row: certificate) {
    var errmsg: string = "";

    if (this.IsRowBroken(row)) {
      errmsg += this.IsCertTypeUndefined(row) ? "CertType is UNDEFINED. " : "";
    }

    return errmsg;
  }

  onChange($event) {
    if ($event.checked) {
      this.showOnlyDistrictSelectInterns = true;
      this.isDistrictSelectCheckboxChecked = true;
    }
    else {
      this.showOnlyDistrictSelectInterns = false;
      this.isDistrictSelectCheckboxChecked = false;
    }
    $event.source.focus();
  }

  removeExpiredCachedFsContacts() {
    const now = new Date();
    const thirtyDaysInMillis = 30 * 24 * 60 * 60 * 1000;

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith('fsContact-')) {
        let cachedItem: CachedFsContact;
        try {
          cachedItem = JSON.parse(localStorage.getItem(key));
        } catch (e) {
          continue;
        }
        if (!cachedItem || !cachedItem.saveDate) {
          continue;
        }
        const cachedDate = new Date(cachedItem.saveDate);
        if (now.getTime() - cachedDate.getTime() > thirtyDaysInMillis) {
          localStorage.removeItem(key);
        }
      }
    }
  }

  ChangeClassByRuleSet(row: certificate) {
    if (this.isExpansionState) {
      return '';
    }

    const isProbationaryCertificate = row.certType.toLowerCase().includes('probationary');

    if (isProbationaryCertificate) {
      return '';
    }

    if (this.isRuleSet2026(row)) {
      return 'ruleSet-2026';
    }

    if (this.getRuleSetYear(row.ruleSet) >= this.newRuleSetStartingYear) {
      return 'new-ruleSet';
    }

    return '';
  }

  private isRuleSet2026(row: certificate): boolean {
    if (!this.ruleSet2026StartDate || !row.ruleSet?.trim().startsWith(this.texasRuleSetPrefix) || !row.trackStart) {
      return false;
    }

    return new Date(row.trackStart) >= this.ruleSet2026StartDate;
  }

  private getRuleSetYear(ruleSet: string): number {
    if (!ruleSet) {
      return 0;
    }
    const year = ruleSet.trim().substring(ruleSet.length - 4);
    return parseInt(year);
  }
}


